var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "blue",
    d: "M6.9994 0C6.44628 0 5.9994 0.446875 5.9994 1V1.6C3.71815 2.0625 1.9994 4.08125 1.9994 6.5V7.0875C1.9994 8.55625 1.45878 9.975 0.483777 11.075L0.252527 11.3344C-0.00997317 11.6281 -0.0724732 12.05 0.0869018 12.4094C0.246277 12.7688 0.605652 13 0.999402 13H12.9994C13.3932 13 13.7494 12.7688 13.9119 12.4094C14.0744 12.05 14.0088 11.6281 13.7463 11.3344L13.515 11.075C12.54 9.975 11.9994 8.55938 11.9994 7.0875V6.5C11.9994 4.08125 10.2807 2.0625 7.9994 1.6V1C7.9994 0.446875 7.55253 0 6.9994 0ZM8.41503 15.4156C8.79003 15.0406 8.9994 14.5312 8.9994 14H6.9994H4.9994C4.9994 14.5312 5.20878 15.0406 5.58378 15.4156C5.95878 15.7906 6.46815 16 6.9994 16C7.53065 16 8.04003 15.7906 8.41503 15.4156Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 3.5,
    r: 2.5,
    fill: "#FD5959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notificationBell.01fbc8fe862dd30a01dc92720bb974ec.svg";
export { ForwardRef as ReactComponent };